import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalHasEmptyAnswers {
  modalIsOpen: boolean;
  toggleModal: () => void;
  finishQuiz: () => void;
  emptyAnswersCount?: number;
}

export function ModalHasEmptyAnswers({
  modalIsOpen,
  toggleModal,
  finishQuiz,
  emptyAnswersCount = 0,
}: IModalHasEmptyAnswers) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerWarning}`}>
        <i className="material-icons-outlined">warning</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.title}>
          <span className={styles.highlightText}>Atenção!</span> Perguntas sem
          resposta.
        </h2>
        <p className={styles.detail}>
          Você tem{' '}
          <strong>
            {emptyAnswersCount}{' '}
            {emptyAnswersCount === 1 ? 'questão' : 'questões'}
          </strong>{' '}
          sem resposta. Tem certeza que deseja prosseguir?
        </p>
        <p className={styles.caption}>
          Questões sem resposta serão contadas como erradas.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Voltar a responder
        </button>
        <button
          onClick={async () => {
            toggleModal();
            finishQuiz();
          }}
          className={styles.btnBack}
          type="button"
        >
          Finalizar quiz
        </button>
      </div>
    </Modal>
  );
}
